import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import BuildingPerformance from './pages/building-performance';
import OccupancyAnalytics from './pages/occupancy-analytics';
import ResidentCheckin from './pages/resident-checkin';
import RoomManagement from './pages/room-management';
import CalendarView from './pages/calendar-view';
import Login from './pages/login';
import ReservationRequest from './pages/reservation-request';
import AdvancedReporting from './pages/advanced-reporting';
import EmailTemplateEditor from './pages/email-template-editor';
import UserManagement from './pages/user-management';
import ClaimsDashboard from './pages/claims-dashboard';
import UpdatePassword from './pages/update-password';
import Restaurant from './pages/restaurant';
import MealTicketSystem from './pages/meal-ticket-system';
import BulkImport from './pages/bulk-import';
// Resident Services Platform
import LostFound from './pages/lost-found';
import CampusMap from './pages/campus-map';
import EmergencyContacts from './pages/emergency-contacts';
import HelpCenter from './pages/help-center';
import NotificationCenter from './pages/notification-center';
import StayHistory from './pages/stay-history';
import ResidentServicesAdmin from './pages/resident-services-admin';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public routes */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/update-password" element={<UpdatePassword />} />

          {/* Admin + Viewer only routes */}
          <Route path="/building-performance" element={<ProtectedRoute requiredRoles={['admin', 'viewer']}><BuildingPerformance /></ProtectedRoute>} />
          <Route path="/occupancy-analytics" element={<ProtectedRoute requiredRoles={['admin', 'viewer']}><OccupancyAnalytics /></ProtectedRoute>} />
          <Route path="/advanced-reporting" element={<ProtectedRoute requiredRoles={['admin', 'viewer']}><AdvancedReporting /></ProtectedRoute>} />
          <Route path="/calendar-view" element={<ProtectedRoute requiredRoles={['admin', 'viewer']}><CalendarView /></ProtectedRoute>} />
          <Route path="/restaurant" element={<ProtectedRoute requiredRoles={['admin', 'viewer']}><Restaurant /></ProtectedRoute>} />
          <Route path="/meal-ticket-system" element={<ProtectedRoute requiredRoles={['admin', 'viewer']}><MealTicketSystem /></ProtectedRoute>} />
          <Route path="/stay-history" element={<ProtectedRoute requiredRoles={['admin', 'viewer']}><StayHistory /></ProtectedRoute>} />
          <Route path="/resident-checkin" element={<ProtectedRoute requiredRoles={['admin', 'viewer']}><ResidentCheckin /></ProtectedRoute>} />

          {/* Admin only routes */}
          <Route path="/room-management" element={<ProtectedRoute requiredRoles={['admin']}><RoomManagement /></ProtectedRoute>} />
          <Route path="/email-template-editor" element={<ProtectedRoute requiredRoles={['admin']}><EmailTemplateEditor /></ProtectedRoute>} />
          <Route path="/user-management" element={<ProtectedRoute requiredRoles={['admin']}><UserManagement /></ProtectedRoute>} />
          <Route path="/claims-dashboard" element={<ProtectedRoute requiredRoles={['admin']}><ClaimsDashboard /></ProtectedRoute>} />
          <Route path="/bulk-import" element={<ProtectedRoute requiredRoles={['admin']}><BulkImport /></ProtectedRoute>} />
          <Route path="/resident-services-admin" element={<ProtectedRoute requiredRoles={['admin']}><ResidentServicesAdmin /></ProtectedRoute>} />

          {/* Reservation Request - all authenticated users */}
          <Route path="/reservation-request" element={<ProtectedRoute><ReservationRequest /></ProtectedRoute>} />

          {/* Resident Services - accessible to ALL authenticated users (guest, viewer, admin) */}
          <Route path="/lost-found" element={<ProtectedRoute><LostFound /></ProtectedRoute>} />
          <Route path="/campus-map" element={<ProtectedRoute><CampusMap /></ProtectedRoute>} />
          <Route path="/emergency-contacts" element={<ProtectedRoute><EmergencyContacts /></ProtectedRoute>} />
          <Route path="/help-center" element={<ProtectedRoute><HelpCenter /></ProtectedRoute>} />
          <Route path="/notification-center" element={<ProtectedRoute><NotificationCenter /></ProtectedRoute>} />

          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
